import React from 'react'
import { Route, Routes } from 'react-router-dom'

import KnowledgePage from '../../pages/features/knowledge/KnowledgePage'

export default function KnowledgeNav() {
    return (
        <Routes>
            <Route path="/" element={<KnowledgePage />} />

       
        </Routes>
    )
}
